// Dutch Fire Product Catalog - Real DiamondFlame Products
export const featuredProducts = [
  // === INBOUWHAARDEN ===
  
  // Fortuna Series (smallest first)
  {
    id: 26,
    name: 'Fortuna 60cm',
    series: 'Fortuna',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Fortuna1.png?v=1705969157',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Fortuna1.png?v=1705969157',
      'https://diamondflame.nl/cdn/shop/files/Fortuna2.png?v=1705969156',
      'https://diamondflame.nl/cdn/shop/files/Fortuna3.png?v=1705969156',
      'https://diamondflame.nl/cdn/shop/files/Fortuna4.png?v=1705969157',
      'https://diamondflame.nl/cdn/shop/files/Fortuna5.png?v=1705969156'
    ],
    dimensions: '60 x 63 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '60cm • Smart LED • Remote',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 34,
    name: 'Fortuna Supreme 72cm',
    series: 'Fortuna Supreme',
    category: 'Inbouwhaarden',
    image: 'https://sfeerhaardkopen.com/cdn/shop/files/1_4d14fb58-9b58-4aa5-9997-15170e0ce26b.jpg?v=1766762782',
    images: [
      'https://sfeerhaardkopen.com/cdn/shop/files/1_4d14fb58-9b58-4aa5-9997-15170e0ce26b.jpg?v=1766762782',
      'https://sfeerhaardkopen.com/cdn/shop/files/2_304e9fc9-b393-44a6-9218-b936f2cda035.jpg?v=1766762783',
      'https://sfeerhaardkopen.com/cdn/shop/files/3_38e5ffec-6645-4ead-82cb-4bdc11eeeb3b.jpg?v=1766762784',
      'https://sfeerhaardkopen.com/cdn/shop/files/4_b168136b-9e7b-4bc1-aa33-e4e10b859090.jpg?v=1766762781',
      'https://sfeerhaardkopen.com/cdn/shop/files/Afmeting_e0497f3c-cc15-4b5f-8f1a-787bae3135a8.png?v=1766762781'
    ],
    dimensions: '72 x 56 x 18.9 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 3 vlamkleuren',
      'Bodemverlichting in 6 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones + witte stenen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Minimale inbouwdiepte van 18.9cm',
      'Inclusief gratis wandmontagebeugel',
      '2 jaar garantie'
    ],
    specs: '72cm • Smart LED • Touchscreen',
    shortDescription: 'Wil je een knusse en warme sfeer creëren in jouw woonkamer, slaapkamer of werkruimte? De Celesta Supreme sfeerhaard zorgt voor een realistisch vlammenspel en warmte.',
    description: 'Wil je een knusse en warme sfeer creëren in jouw woonkamer, slaapkamer of werkruimte? De Celesta Supreme sfeerhaard zorgt voor een realistisch vlammenspel en warmte. Je geniet van de voordelen van een gashaard, maar nu zonder schoorsteen of gasaansluiting. Deze elektrische haard wordt geleverd met een gratis wandmontagebeugel en een decoratieset inclusief luxe houtstammen en kristallen. De Celesta Supreme haard staat bekend om het volledige glaspaneel (Anti Reflective Shield) met daaromheen een zwarte rand. De ventilatieopeningen en het handige touchscreen zitten allebei verwerkt in deze strakke zwarte rand. Je stelt zelf in of je de haard met of zonder verwarming wilt gebruiken. Daarnaast is de verlichting aanpasbaar via het touchscreen en de meegeleverde afstandsbediening. Je hebt de keuze uit 3 verschillende vlamkleuren en maar liefst 6 kleuren bodemverlichting. Zo bepaal je met een druk op de knop de sfeer in huis. Ook pas je eenvoudig de snelheid en lichtintensiteit van de vlammen aan.',
    flameColors: ['Oranje', 'Blauw', 'Goud'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },

  // Royal Diamond Series (sorted by size)
  {
    id: 6,
    name: 'Royal Diamond 106cm',
    series: 'Royal Diamond',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond2.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond3.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond4.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond106cm.png'
    ],
    dimensions: '106 x 43 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '106cm • Smart LED • Touchscreen',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 1,
    name: 'Royal Diamond 50" inch – 127cm',
    series: 'Royal Diamond',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond2.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond3.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond4.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond127cm.png'
    ],
    dimensions: '127 x 43 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '127cm • Smart LED • Touchscreen',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 7,
    name: 'Royal Diamond 60" inch – 152cm',
    series: 'Royal Diamond',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1_774bf3ad-1297-4eaf-b41e-f1f18df8e26a.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1_774bf3ad-1297-4eaf-b41e-f1f18df8e26a.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond2.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond3.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond4.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond152cm.png'
    ],
    dimensions: '152 x 43 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '152cm • Smart LED • Touchscreen',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 8,
    name: 'Royal Diamond 183cm',
    series: 'Royal Diamond',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond2.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond3.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond4.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond183cm.png'
    ],
    dimensions: '183 x 43 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '183cm • Smart LED • Touchscreen',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 9,
    name: 'Royal Diamond 254cm',
    series: 'Royal Diamond',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond2.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond3.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond4.png',
      'https://diamondflame.nl/cdn/shop/files/RoyalDiamond254cm.png'
    ],
    dimensions: '254 x 43 x 14 cm',
    power: '750W / 1500W',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte aluminium omlijsting voor luxe uitstraling',
      'SLT 2.0 - Smart LED Technology met 6 vlamkleuren',
      'Bodemverlichting in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Verwarmingsvermogen: 750W of 1500W',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      '2 jaar garantie'
    ],
    specs: '254cm • Smart LED • Touchscreen',
    shortDescription: 'De Royal Diamond van de Dutch Fires serie geeft jouw woonkamer, slaapkamer of andere ruimte een luxe en moderne uitstraling. Deze sfeerhaard is een perfect alternatief voor een echte gashaard.',
    description: 'De Royal Diamond is bijna niet van echt te onderscheiden. Je geniet van de warmte en knusheid van een echte haard, maar dan zonder gas of schoorsteen! De smalle zwarte aluminium omlijsting zorgt ervoor dat het vlammenspel uitstekend tot zijn recht komt. Daarnaast maakt deze omlijsting de haard uitermate geschikt voor in een cinewall, schouw of wandmeubel. Door de nieuwste Smart LED technologie (SLT 2.0) geniet je van het meest realistische haardvuur. Het is zelfs mogelijk om de vlam én de bodem in verschillende kleuren te projecteren.',
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },

  // Decori Series (sorted by size)
  {
    id: 2,
    name: 'Decori 128cm',
    series: 'Decori',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori2_3dad1ce3-597d-4e8e-a1d8-e766f4d117f3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori3_ec6200d5-41f5-41ea-9cdb-ca4777691640.png',
      'https://diamondflame.nl/cdn/shop/files/Decori4_571d812e-3b7c-43ea-86eb-94dab779e0c5.png'
    ],
    dimensions: '128 x 43 x 14 cm',
    power: 'Geen verwarming',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte glazen omlijsting voor luxe uitstraling',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Hoofdvlam instelbaar in 3 kleuren: oranje, blauw, oranje/blauw',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 4 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Minimale inbouwdiepte van 14cm',
      'Geen afvoerkanalen nodig',
      '2 jaar garantie'
    ],
    specs: '128cm • Smart LED • Touchscreen',
    shortDescription: 'De Decori Slimline sfeerhaard van de Dutch Fires serie kenmerkt zich als luxe elektrische haard zonder verwarming, voorzien van een strak design en volledig voorzien van een ARS (Anti Reflective Shield) glaspaneel.',
    description: 'De Decori Slimline elektrische inbouwhaard oogt modern door de smalle zwarte rand en de minimale inbouwdiepte van 14cm waardoor deze haard prachtig staat aan de wand of in een televisie wand / cinewall. Voor deze elektrische haard heb je geen afvoerkanalen nodig en is eenvoudig in te bouwen. Deze moderne elektrische sfeerhaard met Smart LED technology biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het vlameffect van deze energiezuinige slimline sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel in uw woning, kantoor of restaurant. De decoratie bij deze haard is inbegrepen en bestaat uit luxe houtstammen, doorzichtige kristallen en witte stenen. Door de Multi Colour SMART LED technology (SLT 2.0) is dit model voorzien van de laatste technieken op gebied van elektrisch vuur.',
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 3,
    name: 'Decori 152cm',
    series: 'Decori',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori2_3dad1ce3-597d-4e8e-a1d8-e766f4d117f3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori3_ec6200d5-41f5-41ea-9cdb-ca4777691640.png',
      'https://diamondflame.nl/cdn/shop/files/Decori4_571d812e-3b7c-43ea-86eb-94dab779e0c5.png'
    ],
    dimensions: '152 x 43 x 14 cm',
    power: 'Geen verwarming',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte glazen omlijsting voor luxe uitstraling',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Hoofdvlam instelbaar in 3 kleuren: oranje, blauw, oranje/blauw',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 4 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Minimale inbouwdiepte van 14cm',
      'Geen afvoerkanalen nodig',
      '2 jaar garantie'
    ],
    specs: '152cm • Smart LED • Touchscreen',
    shortDescription: 'De Decori Slimline sfeerhaard van de Dutch Fires serie kenmerkt zich als luxe elektrische haard zonder verwarming, voorzien van een strak design en volledig voorzien van een ARS (Anti Reflective Shield) glaspaneel.',
    description: 'De Decori Slimline elektrische inbouwhaard oogt modern door de smalle zwarte rand en de minimale inbouwdiepte van 14cm waardoor deze haard prachtig staat aan de wand of in een televisie wand / cinewall. Voor deze elektrische haard heb je geen afvoerkanalen nodig en is eenvoudig in te bouwen. Deze moderne elektrische sfeerhaard met Smart LED technology biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het vlameffect van deze energiezuinige slimline sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel in uw woning, kantoor of restaurant. De decoratie bij deze haard is inbegrepen en bestaat uit luxe houtstammen, doorzichtige kristallen en witte stenen. Door de Multi Colour SMART LED technology (SLT 2.0) is dit model voorzien van de laatste technieken op gebied van elektrisch vuur.',
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 4,
    name: 'Decori 183cm',
    series: 'Decori',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori2_3dad1ce3-597d-4e8e-a1d8-e766f4d117f3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori3_ec6200d5-41f5-41ea-9cdb-ca4777691640.png',
      'https://diamondflame.nl/cdn/shop/files/Decori4_571d812e-3b7c-43ea-86eb-94dab779e0c5.png'
    ],
    dimensions: '183 x 43 x 14 cm',
    power: 'Geen verwarming',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte glazen omlijsting voor luxe uitstraling',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Hoofdvlam instelbaar in 3 kleuren: oranje, blauw, oranje/blauw',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 4 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Minimale inbouwdiepte van 14cm',
      'Geen afvoerkanalen nodig',
      '2 jaar garantie'
    ],
    specs: '183cm • Smart LED • Touchscreen',
    shortDescription: 'De Decori Slimline sfeerhaard van de Dutch Fires serie kenmerkt zich als luxe elektrische haard zonder verwarming, voorzien van een strak design en volledig voorzien van een ARS (Anti Reflective Shield) glaspaneel.',
    description: 'De Decori Slimline elektrische inbouwhaard oogt modern door de smalle zwarte rand en de minimale inbouwdiepte van 14cm waardoor deze haard prachtig staat aan de wand of in een televisie wand / cinewall. Voor deze elektrische haard heb je geen afvoerkanalen nodig en is eenvoudig in te bouwen. Deze moderne elektrische sfeerhaard met Smart LED technology biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het vlameffect van deze energiezuinige slimline sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel in uw woning, kantoor of restaurant. De decoratie bij deze haard is inbegrepen en bestaat uit luxe houtstammen, doorzichtige kristallen en witte stenen. Door de Multi Colour SMART LED technology (SLT 2.0) is dit model voorzien van de laatste technieken op gebied van elektrisch vuur.',
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 5,
    name: 'Decori 254cm',
    series: 'Decori',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Decori1_974f838e-598e-49f3-83a1-f97c97432aa3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori2_3dad1ce3-597d-4e8e-a1d8-e766f4d117f3.png',
      'https://diamondflame.nl/cdn/shop/files/Decori3_ec6200d5-41f5-41ea-9cdb-ca4777691640.png',
      'https://diamondflame.nl/cdn/shop/files/Decori4_571d812e-3b7c-43ea-86eb-94dab779e0c5.png',
      'https://diamondflame.nl/cdn/shop/files/ROYALDIAMONDconv5.jpg'
    ],
    dimensions: '254 x 43 x 14 cm',
    power: 'Geen verwarming',
    features: [
      'ARS (Anti Reflective Shield) - Reduceert hinderlijke spiegeling',
      'Zwarte glazen omlijsting voor luxe uitstraling',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Hoofdvlam instelbaar in 3 kleuren: oranje, blauw, oranje/blauw',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 4 standen',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief luxe houtset + crystal ice stones',
      'Minimale inbouwdiepte van 14cm',
      'Geen afvoerkanalen nodig',
      '2 jaar garantie'
    ],
    specs: '254cm • Smart LED • Touchscreen',
    shortDescription: 'De Decori Slimline sfeerhaard van de Dutch Fires serie kenmerkt zich als luxe elektrische haard zonder verwarming, voorzien van een strak design en volledig voorzien van een ARS (Anti Reflective Shield) glaspaneel.',
    description: 'De Decori Slimline elektrische inbouwhaard oogt modern door de smalle zwarte rand en de minimale inbouwdiepte van 14cm waardoor deze haard prachtig staat aan de wand of in een televisie wand / cinewall. Voor deze elektrische haard heb je geen afvoerkanalen nodig en is eenvoudig in te bouwen. Deze moderne elektrische sfeerhaard met Smart LED technology biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het vlameffect van deze energiezuinige slimline sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel in uw woning, kantoor of restaurant. De decoratie bij deze haard is inbegrepen en bestaat uit luxe houtstammen, doorzichtige kristallen en witte stenen. Door de Multi Colour SMART LED technology (SLT 2.0) is dit model voorzien van de laatste technieken op gebied van elektrisch vuur.',
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },

  // Modern Steel Series (sorted by size)
  {
    id: 23,
    name: 'Modern Steel 128cm',
    series: 'Modern Steel',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
    images: [
      'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel2.png?v=1705969895',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel3.png?v=1705969895',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel4.png?v=1705969896',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel5.png?v=1705969896'
    ],
    dimensions: '128 x 63 x 14 cm',
    power: '1400W / 1600W',
    features: ['Stalen matzwarte frame', '3 kleurvlammen', 'LED-bodemverlichting', 'Verwarming'],
    specs: '128cm • LED • Touchscreen',
    description: 'Modern Steel 128cm met robuuste stalen matzwarte frame zoals bij echte gashaarden. Perfect voor cinewalls.'
  },
  {
    id: 24,
    name: 'Modern Steel 152cm',
    series: 'Modern Steel',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
    images: [
      'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel2.png?v=1705969895',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel3.png?v=1705969895'
    ],
    dimensions: '152 x 63 x 14 cm',
    power: '1400W / 1600W',
    features: ['Stalen matzwarte frame', '3 kleurvlammen', 'LED-bodemverlichting', 'Verwarming'],
    specs: '152cm • LED • Touchscreen',
    description: 'Modern Steel 152cm met robuuste stalen matzwarte frame. Ideaal voor grotere cinewalls.'
  },
  {
    id: 25,
    name: 'Modern Steel 183cm',
    series: 'Modern Steel',
    category: 'Inbouwhaarden',
    image: 'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
    images: [
      'https://diamondflame.nl/cdn/shop/files/ModernSteel1.png?v=1705969896',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel2.png?v=1705969895',
      'https://diamondflame.nl/cdn/shop/files/ModernSteel3.png?v=1705969895'
    ],
    dimensions: '183 x 63 x 14 cm',
    power: '1400W / 1600W',
    features: ['Stalen matzwarte frame', '3 kleurvlammen', 'LED-bodemverlichting', 'Verwarming'],
    specs: '183cm • LED • Touchscreen',
    description: 'Modern Steel 183cm met robuuste stalen matzwarte frame. Perfect voor luxe cinewalls.'
  },

  // === 3-ZIJDIGE HAARDEN ===
  
  // Deep Diamond Series (sorted by size)
  {
    id: 27,
    name: 'Deep Diamond 84cm',
    series: 'Deep Diamond',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamond84cm.jpg?v=1759795377',
    images: [
      'https://diamondflame.nl/cdn/shop/files/DeepDiamond84cm.jpg?v=1759795377',
      'https://diamondflame.nl/cdn/shop/files/DeepDiamond84cmtekening.jpg?v=1759795377'
    ],
    dimensions: '84 x 35 x 31 cm',
    specs: '84 x 35 x 31 cm',
    power: '750W / 1500W',
    shortDescription: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden.',
    description: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden. Door de 3D Smart LED technologie geniet je van een realistisch vlammenspel. Het lijkt net alsof je naar een echt haardvuur kijkt. En dat zonder gas of schoorsteen. Met de meegeleverde zijpanelen kan je deze haard ook als fronthaard of hoekhaard inbouwen! Dankzij de speciale diepte effect en het panoramische glas van deze driezijdige haard bekijk je de levensechte vlammen vanuit drie verschillende hoeken. Zo heb je altijd een duidelijk zicht op het vlammenspel. De Deep Diamond heeft zowel instelbare vlamkleuren als bodemverlichting. Stel zelf de warmte, de kleur van de vlammen en de vlamsnelheid in. Jij bent volledig de baas over het haardvuur.',
    features: [
      'Anti Reflective Shield (ARS) - Reduceert hinderlijke spiegeling',
      'Extra diepe haard met gespiegelde achtergrond',
      'Op 3 manieren in te bouwen: fronthaard, hoekhaard (2-zijdig) én als 3-zijdige haard',
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw, geel/goud en multi-colour',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Luxe afstandsbediening',
      'Inclusief luxe houtset (echt hout) + crystal ice stones',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Fronthaard, hoekhaard (2-zijdig) of 3-zijdige haard'
  },
  {
    id: 31,
    name: 'Deep Diamond 160cm',
    series: 'Deep Diamond',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard.jpg?v=1759795057',
    images: [
      'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard.jpg?v=1759795057',
      'https://diamondflame.nl/cdn/shop/files/160cmtekening.jpg?v=1759795057'
    ],
    dimensions: '160 x 35 x 31 cm',
    specs: '160 x 35 x 31 cm',
    power: '750W / 1500W',
    shortDescription: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden.',
    description: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden. Door de 3D Smart LED technologie geniet je van een realistisch vlammenspel. Het lijkt net alsof je naar een echt haardvuur kijkt. En dat zonder gas of schoorsteen. Met de meegeleverde zijpanelen kan je deze haard ook als fronthaard of hoekhaard inbouwen! Dankzij de speciale diepte effect en het panoramische glas van deze driezijdige haard bekijk je de levensechte vlammen vanuit drie verschillende hoeken. Zo heb je altijd een duidelijk zicht op het vlammenspel. De Deep Diamond heeft zowel instelbare vlamkleuren als bodemverlichting. Stel zelf de warmte, de kleur van de vlammen en de vlamsnelheid in. Jij bent volledig de baas over het haardvuur.',
    features: [
      'Anti Reflective Shield (ARS) - Reduceert hinderlijke spiegeling',
      'Extra diepe haard met gespiegelde achtergrond',
      'Op 3 manieren in te bouwen: fronthaard, hoekhaard (2-zijdig) én als 3-zijdige haard',
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw, geel/goud en multi-colour',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Luxe afstandsbediening',
      'Inclusief luxe houtset (echt hout) + crystal ice stones',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Fronthaard, hoekhaard (2-zijdig) of 3-zijdige haard'
  },
  {
    id: 32,
    name: 'Deep Diamond 220cm',
    series: 'Deep Diamond',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard_79e1bf72-c325-4cb6-a105-cc386b2874ca.jpg?v=1759795062',
    images: [
      'https://diamondflame.nl/cdn/shop/files/DeepDiamondhaard_79e1bf72-c325-4cb6-a105-cc386b2874ca.jpg?v=1759795062',
      'https://diamondflame.nl/cdn/shop/files/220cmtekening.jpg?v=1759795062'
    ],
    dimensions: '220 x 35 x 31 cm',
    specs: '220 x 35 x 31 cm',
    power: '750W / 1500W',
    shortDescription: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden.',
    description: 'De Deep Diamond sfeerhaard zorgt voor gezelligheid in iedere ruimte. De haard is volledig elektrisch en is niet van een echte gashaard te onderscheiden. Door de 3D Smart LED technologie geniet je van een realistisch vlammenspel. Het lijkt net alsof je naar een echt haardvuur kijkt. En dat zonder gas of schoorsteen. Met de meegeleverde zijpanelen kan je deze haard ook als fronthaard of hoekhaard inbouwen! Dankzij de speciale diepte effect en het panoramische glas van deze driezijdige haard bekijk je de levensechte vlammen vanuit drie verschillende hoeken. Zo heb je altijd een duidelijk zicht op het vlammenspel. De Deep Diamond heeft zowel instelbare vlamkleuren als bodemverlichting. Stel zelf de warmte, de kleur van de vlammen en de vlamsnelheid in. Jij bent volledig de baas over het haardvuur.',
    features: [
      'Anti Reflective Shield (ARS) - Reduceert hinderlijke spiegeling',
      'Extra diepe haard met gespiegelde achtergrond',
      'Op 3 manieren in te bouwen: fronthaard, hoekhaard (2-zijdig) én als 3-zijdige haard',
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw, geel/goud en multi-colour',
      'Multi Colour SMART LED technology (SLT 2.0)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid instelbaar in 5 standen',
      'Vlamsnelheid instelbaar in 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Luxe afstandsbediening',
      'Inclusief luxe houtset (echt hout) + crystal ice stones',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Fronthaard, hoekhaard (2-zijdig) of 3-zijdige haard'
  },

  // Mazar Series (sorted by size)
  {
    id: 13,
    name: 'Mazar 36" inch – 91cm',
    series: 'Mazar',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_2_c9b62f9c-0adb-43ba-8793-6c56729b9c99.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_3_21966c0c-2f45-4a4c-8e3c-125984e4f12b.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_4_8f41bea3-f553-4760-a496-2ba635c9c4e7.png'
    ],
    dimensions: '91 x 43 x 14 cm',
    specs: '91 x 43 x 14 cm',
    power: '750W / 1500W',
    shortDescription: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant.',
    description: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant. Deze haard is uitermate geschikt voor een cinewall, schouw of een wandmeubel en werkt met en zonder verwarming. Door het 3D aanzicht met breed en hoog panoramisch glas is het opmerkelijke vlammeneffect vanuit elke hoek te bewonderen. Binnen minuten wordt een gemoedelijke, ontspannen omgeving gecreëerd. Deze unieke elektrische 3D haard met de Smart LED Technology (SLT) biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het levensechte vuurbeeld van deze energiezuinige Mazar sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel. Deze sfeerhaard charmeert bovendien door zijn moderne en hoogwaardige look en beschikt over een Anti Reflective Shield (ARS) en reduceert hierdoor hinderlijke spiegeling. De bodemverlichtinging verwerkt met luxe houtblokken kan in maar liefst 10 verschillende kleuren worden ingesteld. De vlammen van deze haard zijn in snelheid regelbaar (5 standen) en tevens is de licht intensiteit (5 standen) regelbaar. Deze haard is in meerdere formaten beschikbaar en biedt daardoor enorm veel installatie mogelijkheden. De sfeerhaard kan zowel opgehangen worden met de gratis wandmontagebeugel of kan gemonteerd worden als inbouwhaard.',
    features: [
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw en geel/goud',
      'Multi Colour SMART LED technology (SLT)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid: 5 standen',
      'Vlamsnelheid: 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Anti Reflective Shield (ARS)',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief Deluxe houtset + crystal ice stones',
      'Muurbeugel inbegrepen',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 14,
    name: 'Mazar 50" inch – 128cm',
    series: 'Mazar',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_2_c9b62f9c-0adb-43ba-8793-6c56729b9c99.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_3_21966c0c-2f45-4a4c-8e3c-125984e4f12b.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_4_8f41bea3-f553-4760-a496-2ba635c9c4e7.png'
    ],
    dimensions: '128 x 43 x 14 cm',
    specs: '128 x 43 x 14 cm',
    power: '750W / 1500W',
    shortDescription: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant.',
    description: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant. Deze haard is uitermate geschikt voor een cinewall, schouw of een wandmeubel en werkt met en zonder verwarming. Door het 3D aanzicht met breed en hoog panoramisch glas is het opmerkelijke vlammeneffect vanuit elke hoek te bewonderen. Binnen minuten wordt een gemoedelijke, ontspannen omgeving gecreëerd. Deze unieke elektrische 3D haard met de Smart LED Technology (SLT) biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het levensechte vuurbeeld van deze energiezuinige Mazar sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel. Deze sfeerhaard charmeert bovendien door zijn moderne en hoogwaardige look en beschikt over een Anti Reflective Shield (ARS) en reduceert hierdoor hinderlijke spiegeling. De bodemverlichtinging verwerkt met luxe houtblokken kan in maar liefst 10 verschillende kleuren worden ingesteld. De vlammen van deze haard zijn in snelheid regelbaar (5 standen) en tevens is de licht intensiteit (5 standen) regelbaar. Deze haard is in meerdere formaten beschikbaar en biedt daardoor enorm veel installatie mogelijkheden. De sfeerhaard kan zowel opgehangen worden met de gratis wandmontagebeugel of kan gemonteerd worden als inbouwhaard.',
    features: [
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw en geel/goud',
      'Multi Colour SMART LED technology (SLT)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid: 5 standen',
      'Vlamsnelheid: 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Anti Reflective Shield (ARS)',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief Deluxe houtset + crystal ice stones',
      'Muurbeugel inbegrepen',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 15,
    name: 'Mazar 60" inch – 152cm',
    series: 'Mazar',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_2_c9b62f9c-0adb-43ba-8793-6c56729b9c99.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_3_21966c0c-2f45-4a4c-8e3c-125984e4f12b.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_4_8f41bea3-f553-4760-a496-2ba635c9c4e7.png'
    ],
    dimensions: '152 x 43 x 14 cm',
    specs: '152 x 43 x 14 cm',
    power: '750W / 1500W',
    shortDescription: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant.',
    description: 'Deze prachtige driezijdige elektrische haard van het merk Mazar tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant. Deze haard is uitermate geschikt voor een cinewall, schouw of een wandmeubel en werkt met en zonder verwarming. Door het 3D aanzicht met breed en hoog panoramisch glas is het opmerkelijke vlammeneffect vanuit elke hoek te bewonderen. Binnen minuten wordt een gemoedelijke, ontspannen omgeving gecreëerd. Deze unieke elektrische 3D haard met de Smart LED Technology (SLT) biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het levensechte vuurbeeld van deze energiezuinige Mazar sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel. Deze sfeerhaard charmeert bovendien door zijn moderne en hoogwaardige look en beschikt over een Anti Reflective Shield (ARS) en reduceert hierdoor hinderlijke spiegeling. De bodemverlichtinging verwerkt met luxe houtblokken kan in maar liefst 10 verschillende kleuren worden ingesteld. De vlammen van deze haard zijn in snelheid regelbaar (5 standen) en tevens is de licht intensiteit (5 standen) regelbaar. Deze haard is in meerdere formaten beschikbaar en biedt daardoor enorm veel installatie mogelijkheden. De sfeerhaard kan zowel opgehangen worden met de gratis wandmontagebeugel of kan gemonteerd worden als inbouwhaard.',
    features: [
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw en geel/goud',
      'Multi Colour SMART LED technology (SLT)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid: 5 standen',
      'Vlamsnelheid: 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Anti Reflective Shield (ARS)',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief Deluxe houtset + crystal ice stones',
      'Muurbeugel inbegrepen',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 16,
    name: 'Mazar 3D 72" inch – 183cm',
    series: 'Mazar 3D',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_2_c9b62f9c-0adb-43ba-8793-6c56729b9c99.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_3_21966c0c-2f45-4a4c-8e3c-125984e4f12b.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_4_8f41bea3-f553-4760-a496-2ba635c9c4e7.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_183cm.png'
    ],
    dimensions: '183 x 44 x 20 cm',
    specs: '183 x 44 x 20 cm',
    power: '750W / 1500W',
    shortDescription: 'Deze prachtige driezijdige elektrische haard van het merk Mazar 3D tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant.',
    description: 'Deze prachtige driezijdige elektrische haard van het merk Mazar 3D tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant. Deze haard is uitermate geschikt voor een cinewall, schouw of een wandmeubel en werkt met en zonder verwarming. Door het 3D aanzicht met breed en hoog panoramisch glas is het opmerkelijke vlammeneffect vanuit elke hoek te bewonderen. Binnen minuten wordt een gemoedelijke, ontspannen omgeving gecreëerd. Deze unieke elektrische 3D haard met de Smart LED Technology (SLT) biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het levensechte vuurbeeld van deze energiezuinige Mazar 3D sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel. Deze sfeerhaard charmeert bovendien door zijn moderne en hoogwaardige look en beschikt over een Anti Reflective Shield (ARS) en reduceert hierdoor hinderlijke spiegeling. De bodemverlichtinging verwerkt met luxe houtblokken kan in maar liefst 10 verschillende kleuren worden ingesteld. De vlammen van deze haard zijn in snelheid regelbaar (5 standen) en tevens is de licht intensiteit (5 standen) regelbaar. Deze haard is in meerdere formaten beschikbaar en biedt daardoor enorm veel installatie mogelijkheden. De sfeerhaard kan zowel opgehangen worden met de gratis wandmontagebeugel of kan gemonteerd worden als inbouwhaard.',
    features: [
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw en geel/goud',
      'Multi Colour SMART LED technology (SLT)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid: 5 standen',
      'Vlamsnelheid: 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Anti Reflective Shield (ARS)',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief Deluxe houtset + crystal ice stones',
      'Muurbeugel inbegrepen',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje', 'Blauw', 'Goud', 'Oranje/Blauw', 'Geel/Goud', 'Multi-colour'],
    usage: 'Inbouwhaard, wandhaard, inzethaard of als tv haard'
  },
  {
    id: 11,
    name: 'Mazar 3D 100" inch – 254cm',
    series: 'Mazar 3D',
    category: '3-zijdige Haarden',
    image: 'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
    images: [
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_1_f14e2fdb-5706-43cb-bae8-ccd5d8c08f5e.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_2_c9b62f9c-0adb-43ba-8793-6c56729b9c99.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_3_21966c0c-2f45-4a4c-8e3c-125984e4f12b.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_4_8f41bea3-f553-4760-a496-2ba635c9c4e7.png',
      'https://diamondflame.nl/cdn/shop/files/Mazar-3D_254cm_d64897f0-3ad8-4d63-9239-ff829d2e6029.png'
    ],
    dimensions: '254 x 44 x 20 cm',
    specs: '254 x 44 x 20 cm',
    power: '750W / 1500W',
    shortDescription: 'Deze prachtige driezijdige elektrische haard van het merk Mazar 3D tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant.',
    description: 'Deze prachtige driezijdige elektrische haard van het merk Mazar 3D tovert een romantische en sfeervolle atmosfeer in uw woning, kantoor of restaurant. Deze haard is uitermate geschikt voor een cinewall, schouw of een wandmeubel en werkt met en zonder verwarming. Door het 3D aanzicht met breed en hoog panoramisch glas is het opmerkelijke vlammeneffect vanuit elke hoek te bewonderen. Binnen minuten wordt een gemoedelijke, ontspannen omgeving gecreëerd. Deze unieke elektrische 3D haard met de Smart LED Technology (SLT) biedt een huiselijke en sfeervolle warmte waar u maar wilt. Het levensechte vuurbeeld van deze energiezuinige Mazar 3D sfeerhaard geeft een zeer levendig, realistisch en sfeervol vlammenspel. Deze sfeerhaard charmeert bovendien door zijn moderne en hoogwaardige look en beschikt over een Anti Reflective Shield (ARS) en reduceert hierdoor hinderlijke spiegeling. De bodemverlichtinging verwerkt met luxe houtblokken kan in maar liefst 10 verschillende kleuren worden ingesteld. De vlammen van deze haard zijn in snelheid regelbaar (5 standen) en tevens is de licht intensiteit (5 standen) regelbaar. Deze haard is in meerdere formaten beschikbaar en biedt daardoor enorm veel installatie mogelijkheden. De sfeerhaard kan zowel opgehangen worden met de gratis wandmontagebeugel of kan gemonteerd worden als inbouwhaard.',
    features: [
      'Hoofdvlam instelbaar in 6 kleuren: oranje, blauw, goud, oranje/blauw en geel/goud',
      'Multi Colour SMART LED technology (SLT)',
      'Bodemverlichting instelbaar in 10 kleuren',
      'Vlamhelderheid: 5 standen',
      'Vlamsnelheid: 5 standen',
      'Verwarmingsvermogen: 750W of 1500W',
      'Werkt met en zonder verwarming',
      'Digitale thermostaat instelbaar',
      'Oververhittingsbeveiliging',
      'Anti Reflective Shield (ARS)',
      'Touchscreen + luxe afstandsbediening',
      'Inclusief Deluxe houtset + crystal ice stones',
      'Muurbeugel inbegrepen',
      '2 jaar garantie'
    ]
  },

  // === VRIJSTAANDE HAARDEN ===
  
  // Verdi Fires
  {
    id: 33,
    name: 'Verdi Fires',
    series: 'Verdi Fires',
    category: 'Vrijstaande Haarden',
    image: 'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires0.jpg?v=1766689629',
    images: [
      'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires0.jpg?v=1766689629',
      'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires1.jpg?v=1766689629',
      'https://sfeerhaardkopen.com/cdn/shop/files/Verdi-fires_5.png?v=1767061140',
      'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires2.jpg?v=1767061140',
      'https://sfeerhaardkopen.com/cdn/shop/files/VerdiFires3.jpg?v=1767061140'
    ],
    dimensions: 'Vrijstaand model',
    specs: 'Vrijstaand • 3-zijdig vuurzicht • Handbediening',
    power: '1000W / 2000W',
    shortDescription: 'Breng warmte, sfeer en stijl samen met deze vrijstaande elektrische sfeerhaard van Verdi Fires. Dankzij het realistische vlameffect en het karaktervolle ontwerp creëert deze haard direct een gezellige, luxe ambiance in iedere ruimte.',
    description: 'Breng warmte, sfeer en stijl samen met deze vrijstaande elektrische sfeerhaard van Verdi Fires. Dankzij het realistische vlameffect en het karaktervolle ontwerp creëert deze haard direct een gezellige, luxe ambiance in iedere ruimte. Of u nu extra sfeer wilt toevoegen aan uw woonkamer, slaapkamer, kantoor, tuinkamer of zelfs garage: deze elektrische haard is een veelzijdige en stijlvolle keuze. Het levensechte vlambeeld zorgt voor een warme uitstraling zonder rook, roet of onderhoud. De haard is volledig elektrisch en daardoor eenvoudig te plaatsen — u heeft enkel een stopcontact nodig. Dankzij het compacte en vrijstaande ontwerp is de haard bovendien gemakkelijk te verplaatsen en flexibel inzetbaar in verschillende ruimtes. Naast zijn decoratieve waarde functioneert deze haard ook als bijverwarming. Met twee instelbare verwarmingsstanden van 1000 en 2000 watt stemt u de warmte moeiteloos af op uw persoonlijke comfortbehoefte. Hierdoor is de haard geschikt voor ruimtes van circa 20 tot 25 m² en ideaal als extra warmtebron tijdens koudere dagen. Het open vak aan de onderzijde biedt ruimte voor houtopslag (decoratief), wat de authentieke en rustieke uitstraling van de haard versterkt.',
    features: [
      'Realistisch en sfeervol vlameffect',
      'Vrijstaand en eenvoudig te verplaatsen',
      '3-zijdig vuurzicht',
      'Twee verwarmingsstanden: 1000W / 2000W',
      'Geschikt voor ruimtes van 20–25 m²',
      'Ideaal als bijverwarming',
      'Ingebouwde veiligheidsuitschakeling',
      'Onderhoudsvrij en volledig elektrisch',
      'Rustieke afwerking met decoratieve houtopslag',
      'Handbediening',
      'Afvoerloos',
      '2 jaar garantie'
    ],
    flameColors: ['Oranje'],
    usage: 'Vrijstaande haard voor woonkamer, slaapkamer, kantoor of tuinkamer'
  }
];

export const categories = [
  {
    id: 1,
    name: 'Wandkamine',
    slug: 'wall-fireplaces',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1.png?v=1705963901',
    modelCount: 9
  },
  {
    id: 2,
    name: 'Einbaukamine',
    slug: 'built-in-fireplaces',
    image: 'https://diamondflame.nl/cdn/shop/files/RoyalDiamond1_774bf3ad-1297-4eaf-b41e-f1f18df8e26a.png?v=1705964332',
    modelCount: 9
  },
  {
    id: 3,
    name: '3-seitige Kamine',
    slug: 'three-sided-fireplaces',
    image: 'https://diamondflame.nl/cdn/shop/files/DeepDiamond84cm.jpg?v=1759795377',
    modelCount: 6
  }
];

export const inspirationProjects = [
  {
    id: 1,
    title: 'Luxe Cinewall met Dutch Fire Decori',
    location: 'Amsterdam',
    model: 'Decori 183cm',
    image: 'https://public.readdy.ai/ai/img_res/714e4d6165eb098292d0299a14bba6b0.jpg',
    type: 'large'
  },
  {
    id: 2,
    title: 'Premium Villa Cinewall met Royal Diamond',
    location: 'München',
    model: 'Royal Diamond 254cm',
    image: 'https://readdy.ai/api/search-image?query=stunning%20luxury%20villa%20living%20room%20with%20custom%20built%20cinewall%20featuring%2085%20inch%20TV%20above%20wide%20panoramic%20electric%20fireplace%20with%20dancing%20flames%20black%20matte%20wall%20panels%20integrated%20LED%20backlighting%20beige%20sectional%20sofa%20floor%20to%20ceiling%20windows%20evening%20ambiance%20premium%20interior%20design&width=800&height=600&seq=cinewall02&orientation=landscape',
    type: 'large'
  },
  {
    id: 3,
    title: 'Strakke Penthouse Mediawand',
    location: 'Rotterdam',
    model: 'Decori 152cm',
    image: 'https://readdy.ai/api/search-image?query=modern%20penthouse%20apartment%20media%20wall%20entertainment%20center%20with%20mounted%20television%20above%20linear%20electric%20fireplace%20realistic%20flame%20effect%20dark%20grey%20textured%20wall%20panels%20recessed%20ceiling%20lights%20contemporary%20minimalist%20furniture%20warm%20ambient%20lighting%20luxury%20urban%20living&width=600&height=800&seq=cinewall03&orientation=portrait',
    type: 'small'
  },
  {
    id: 4,
    title: 'Exclusieve Woonkamer met Mazar 3D',
    location: 'Berlin',
    model: 'Mazar 3D 183cm',
    image: 'https://readdy.ai/api/search-image?query=exclusive%20high%20end%20living%20room%20interior%20with%20custom%20cinewall%20three%20sided%20panoramic%20electric%20fireplace%20beneath%20large%20smart%20TV%20walnut%20wood%20veneer%20wall%20panels%20indirect%20warm%20lighting%20plush%20velvet%20sofa%20marble%20coffee%20table%20sophisticated%20evening%20atmosphere%20luxury%20residential&width=800&height=600&seq=cinewall04&orientation=landscape',
    type: 'medium'
  },
  {
    id: 5,
    title: 'Designer Cinewall Project',
    location: 'Brussel',
    model: 'Royal Diamond 183cm',
    image: 'https://readdy.ai/api/search-image?query=designer%20luxury%20cinewall%20installation%20with%20frameless%20TV%20integrated%20above%20wide%20electric%20fireplace%20with%20orange%20flame%20effect%20white%20marble%20surround%20dark%20oak%20wood%20panels%20ambient%20strip%20lighting%20cream%20colored%20interior%20modern%20furniture%20premium%20residential%20project&width=800&height=600&seq=cinewall05&orientation=landscape',
    type: 'medium'
  },
  {
    id: 6,
    title: 'Maatwerk TV-wand met Deep Diamond',
    location: 'Paris',
    model: 'Deep Diamond 220cm',
    image: 'https://readdy.ai/api/search-image?query=bespoke%20custom%20media%20wall%20with%20large%20television%20mounted%20above%20extra%20wide%20three%20sided%20electric%20fireplace%20with%20realistic%20flames%20charcoal%20grey%20stucco%20finish%20hidden%20LED%20lighting%20luxurious%20cream%20sofa%20gold%20accents%20evening%20mood%20lighting%20high%20end%20apartment%20interior&width=800&height=600&seq=cinewall06&orientation=landscape',
    type: 'large'
  }
];

export const testimonials = [
  {
    id: 1,
    company: 'Haarden & Interieur BV',
    country: 'Nederland',
    flag: '🇳🇱',
    quote: 'Dutch Fire heeft onze productlijn naar een hoger niveau getild. De kwaliteit is uitstekend en onze klanten zijn zeer tevreden. De ondersteuning vanuit het hoofdkantoor is professioneel en snel.',
    rating: 5,
    since: '2022'
  },
  {
    id: 2,
    company: 'Kamin Studio Berlin',
    country: 'Deutschland',
    flag: '🇩🇪',
    quote: 'Als premium dealer zijn we zeer tevreden met de samenwerking. De marges zijn goed, de producten verkopen zichzelf en het marketingmateriaal is van topkwaliteit.',
    rating: 5,
    since: '2021'
  },
  {
    id: 3,
    company: 'Cheminées Élégance',
    country: 'France',
    flag: '🇫🇷',
    quote: 'Nous travaillons avec Dutch Fire depuis 3 ans. Excellent rapport qualité-prix, livraison rapide et support technique impeccable. Nos clients adorent ces cheminées.',
    rating: 5,
    since: '2020',
    featured: true
  },
  {
    id: 4,
    company: 'FirePlace Solutions Ltd',
    country: 'United Kingdom',
    flag: '🇬🇧',
    quote: 'The product quality and dealer support are outstanding. Dutch Fire has become our primary supplier for electric fireplaces. Highly recommended for serious dealers.',
    rating: 5,
    since: '2023'
  },
  {
    id: 5,
    company: 'Kominek Design',
    country: 'Polska',
    flag: '🇵🇱',
    quote: 'Profesjonalna współpraca na najwyższym poziomie. Produkty Dutch Fire cieszą się ogromnym zainteresowaniem naszych klientów. Szkolenia techniczne są bardzo pomocne.',
    rating: 5,
    since: '2022'
  },
  {
    id: 6,
    company: 'Interior Flames SA',
    country: 'België',
    flag: '🇧🇪',
    quote: 'Dutch Fire combineert kwaliteit met stijl. Onze projecten met deze haarden worden altijd goed ontvangen. De exclusieve gebiedsrechten zijn een groot voordeel.',
    rating: 5,
    since: '2021'
  },
  {
    id: 7,
    company: 'Camini Moderni SRL',
    country: 'Italia',
    flag: '🇮🇹',
    quote: 'Prodotti eccellenti e supporto commerciale fantastico. Dutch Fire è il partner ideale per rivenditori professionali nel settore premium.',
    rating: 5,
    since: '2023'
  }
];
